export default {
    'Tutor': 'Тьютор',
    'Lesson_booked': 'Урок заброньовано',
    'Group': 'Група',
    'Format': 'Формат',
    'Link_making_lesson': 'Посилання на відпрацювання',
    'Comment': 'Коментар',
    'Phone': 'Телефон',
    'Close': 'Закрити',
    'Cancel_your_booking': 'Скасувати запис',
    'Making_lessons': 'Відпрацювання уроків',
    'You_make_missed_classes': 'Список пропуcків',
    'Select_free_time_slots': 'Для запису до Тьютора оберіть вільні слоти часу та <br/> натисніть на кнопку “Запис на відпрацювання”.',
    's_week': 'Вкажіть тиждень',
    'Book_up_lesson': 'Записатися',
    'The_lesson_booked': 'Заброньовано вами',
    'Lesson': 'Урок',
    'Booked': 'Заброньовано',
    'worked': 'відпрацьовано',
    'Select_least_time': 'Ви повинні вибрати хоча б один осередок часу.',
    'Period_successfully_removed': 'Перiод успішно видалений.',
    'no_possibility_3_blank_spaces': 'Ви не маєте можливості вибрати більше 3-х слотів.',
    'no_possibility_3_classes_per_day': 'Ви не маєте можливості відпрацювати більше 3-х уроків за один день.',
    'no_more_classes_left': 'Ви не маєте більше уроків для відпрацювання.',
    'Successfully': 'Успішно',
    'Date':'Дата',
    'Time':'Час',
    'Program':'Програма',
    'Save': 'Зберегти',
    'Book_making_lesson': 'Запис на відпрацювання',
    'class_missed':'Пропущене заняття',
    'offline_class':'В класі',
    'online_class':'Онлайн',
    'show_more': 'Показати ще',
    'messages': 'Повідомлення',
    'groups_list': 'Оберіть групу',
    'Good': 'Добре',
    'Days': 'Дні',
    'Hours': 'Години',
    'Minutes': 'Хвилини',
    'Seconds': 'Секунди',
    'Access to the lesson will be closed through:': 'Доступ до уроку закриється через:',
};
